import { useQuery } from '@tanstack/react-query'
import { DemographicsDistributionCard } from '../sponsorship/DemographicsDistributionCard'
import { SPONSOR_QUERY_KEYS } from '@/api/queryKeys'
import { getDemographicsData } from '@/api/sponsorApi'
import { DASHBOARD_DATA_FETCH_TIMEOUT } from '@/constants'
import { useMemo } from 'react'
import { processDemographicsData } from '@/utils/demographics'
import type { EventSelectValue } from '../event/EventSelect'

interface SponsorDemographicsDataProps {
  selectedEvent: EventSelectValue | null
}

function SponsorDemographicsData({
  selectedEvent,
}: Readonly<SponsorDemographicsDataProps>) {
  const {
    data: demographicsRaw,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [SPONSOR_QUERY_KEYS.demographicsData, selectedEvent],
    queryFn: () =>
      getDemographicsData({
        ...(selectedEvent && { eventId: selectedEvent?.id }),
      }),
    refetchInterval: DASHBOARD_DATA_FETCH_TIMEOUT,
    refetchIntervalInBackground: true,
  })

  const { geographicList, ageChartData } = useMemo(
    () => processDemographicsData(demographicsRaw),
    [demographicsRaw]
  )

  return (
    <DemographicsDistributionCard
      isLoading={isLoading}
      isError={isError}
      geographicList={geographicList}
      ageChartData={ageChartData}
    />
  )
}

export default SponsorDemographicsData
